module.exports = __webpack_public_path__ + "static/media/feat-cumberland-img2.84a02738.jpg";